import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from '../../lib/lucide-proxy';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Plataforma': [
      { name: 'Como Funciona', href: '/como-funciona' },
      { name: 'Cervejarias', href: '/cervejarias' },
      { name: 'Blog', href: '/blog' }
    ],
    'Parceiros': [
      { name: 'Cadastre sua Cervejaria', href: '/register' },
      { name: 'Portal do Parceiro', href: '/login' }
    ],
    'Legal': [
      { name: 'Termos de Uso', href: '/termos' },
      { name: 'Privacidade', href: '/privacidade' }
    ]
  };

  return (
    <footer className="bg-dark-900 text-cream-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">C</span>
              </div>
              {/* BRANDING UPDATE */}
              <span className="font-display font-bold text-xl text-cream-300">
                Cerveja <span className="text-primary-500">Delivery</span>
              </span>
            </Link>
            <p className="text-cream-400 mb-6 text-sm leading-relaxed">
              A maior plataforma de descoberta de cervejarias artesanais. Conectando apreciadores diretamente aos produtores locais.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-primary-500" />
                <span className="text-cream-400">Brasil</span>
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">{title}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.href}
                      className="text-cream-400 hover:text-primary-500 transition-colors duration-200 text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-dark-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="text-cream-500">
            © {currentYear} Cerveja Delivery. Todos os direitos reservados.
          </p>
          <p className="text-cream-600 mt-2 md:mt-0">
            Aprecie com moderação. 🔞
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;